import { InputWhite } from "@UI/New/InputWhite";
import s from './index.module.css';

export const NumberOfLessons = ({state, setFieldInState}) => {
   
    return (
        <InputWhite 
          type='number'
          className={s.input}
          value={state.number_of_lessons} 
          onChange={(value) => setFieldInState({field: 'number_of_lessons', value})} />
    );
}